<template>
  <qc-container title="分类管理">
    <div class="flex">
      <div class="flex-1">
        <classify-list :type="type" @click-node="clickNode"> </classify-list>
      </div>
      <span style="width: 30px">&nbsp;</span>
      <div class="flex-1">
        <classify-list :type="type" :level="2" :parentObj="parentObj"></classify-list>
      </div>
    </div>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import ClassifyList from "@view/components/classify/classify-list.vue";

export default {
  props:{
    //0线上 1门店
    type:{
      type:Number,
      default:0
    }
  },
  name: "classify-index",
  components: {ClassifyList, QcContainer},
  data() {
    return {
      parentObj:{id:""},
    }
  },
  mixins: [tableBase],
  methods: {
    clickNode(row){
      this.parentObj = row;
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
